export default {
	methods: {
        getUserFriendlyStatus(status) {
            switch(status) {
                case 'Pending':
                    return 'Pending';
                case 'InProgress':
                    return 'In Progress';
                case 'Discussion':
                    return 'Discussion Ready';
                case 'Complete':
                    return 'Complete';
            }
            return 'N/A';
        },
	}
};
